import { createFileRoute } from "@tanstack/react-router";
import { requireMe } from "../../features/auth/guard";
import { OnboardingPage } from "../../features/onboarding/components/onboarding-page";

/** FR-ACC-02: the first thing a new account sees; also how anyone starts another workspace. */
export const Route = createFileRoute("/onboarding/workspace")({
  beforeLoad: async ({ context, location }) => {
    await requireMe(context.queryClient, location.href);
  },
  component: OnboardingPage,
});
